<template>
    <div id="edicaoAtracoesArtisticas">
        <validation-observer ref="validationobserver" v-slot="{ handleSubmit }">
            <b-form @submit.prevent="handleSubmit(salvar)" class="">
                <b-row>
                    <b-col cols="6">
                        <h5 class="text-left">{{ editItem ? 'Atualizar' : 'Adicionar' }} Atração Artística</h5>
                    </b-col>
                    <b-col cols="6">
                        <b-button type="submit" size="sm" class="float-right mx-2">
                            <font-awesome-icon :icon="editItem ? 'edit' : 'plus'" />
                            {{ editItem ? 'Alterar' : 'Adicionar' }} Atração Artística
                        </b-button>
                        <b-button v-if="editItem" @click.prevent="limparForm" size="sm" variant="danger"
                            class="float-right">
                            <font-awesome-icon icon="ban" />
                            Cancelar alteração
                        </b-button>
                        <b-button v-if="!editItem" size="sm" class="float-right mx-2"
                            @click="exibirModalImportacao = true">
                            <font-awesome-icon icon="cloud-upload" class="" />
                            Importar Atrações
                        </b-button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" sm="6" xl="4">
                        <default-form-validation-provider v-if="listaNomes" label="Nome da atração"
                            v-slot="defaultState" tag="div">
                            <div id="nomeSelectWrapper" class="wrapper-multiselect-sagres"
                                :class="{ 'invalid': nomeSelect.value === null, 'valid': nomeSelect.value !== null }">
                                <multiselect v-model="nomeSelect" close-on-select searchable :show-labels="false"
                                    label="text" deselect-label="" :allow-empty="true" placeholder="Selecione"
                                    track-by="text" :options="listaNomes" class="w-100" :disabled="!listaNomes"
                                    :state="defaultState.state" @input="selectNomeAtualizado">
                                    <template slot="noOptions">
                                        <small><i>Nenhum nome cadastrado</i></small>
                                    </template>
                                    <template slot="noResult">
                                        <i>Nenhuma nom selecionado</i>
                                    </template>
                                </multiselect>
                            </div>
                        </default-form-validation-provider>
                        <default-form-validation-provider noLabel v-if="nomeSelect.value === 0" v-slot="defState"
                            rules="required|max:100">
                            <b-form-input v-model="novoItem.NmAtracao" :state="defState.state"></b-form-input>
                        </default-form-validation-provider>
                    </b-col>
                    <b-col cols="12" sm="6" xl="4">
                        <default-form-validation-provider label="Razão Social da atração" v-slot="defState"
                            rules="max:100">
                            <b-form-input v-model="novoItem.NmFiscalAtracao" :state="defState.state"></b-form-input>
                        </default-form-validation-provider>
                    </b-col>
                    <b-col cols="12" sm="6" xl="4">
                        <default-form-validation-provider label="CPF/CNPJ da Atração Artística (apenas números)"
                            v-slot="defState" rules="max:14">
                            <b-form-input v-model="novoItem.CdCpfCnpjAtracaoArtistica"
                                :state="defState.state"></b-form-input>
                        </default-form-validation-provider>
                    </b-col>
                    <b-col cols="12" sm="6" xl="4">
                        <default-form-validation-provider label="Razão Social do Representante Legal" v-slot="defState"
                            rules="max:100">
                            <b-form-input v-model="novoItem.NmRazaoSocialRepresentante"
                                :state="defState.state"></b-form-input>
                        </default-form-validation-provider>
                    </b-col>
                    <b-col cols="12" sm="6" xl="4">
                        <default-form-validation-provider label="CPF/CNPJ do Representante Legal (apenas números)"
                            v-slot="defState" rules="max:14">
                            <b-form-input v-model="novoItem.CdCpfCnpjRepresentanteLegal"
                                :state="defState.state"></b-form-input>
                        </default-form-validation-provider>
                    </b-col>
                    <b-col cols="12" sm="6" xl="4">
                        <default-form-validation-provider label="Valor Estimado" v-slot="defState">
                            <money class="form-control" v-model="novoItem.VlAtracao" :state="defState.state"
                                v-bind="vMoneyOptions"></money>
                        </default-form-validation-provider>
                    </b-col>
                    <b-col cols="12" sm="6" xl="4">
                        <default-form-validation-provider label="Data da Apresentação" v-slot="defaultState">
                            <b-form-datepicker id="input-data-inicio" :state="defaultState.state"
                                v-model="novoItem.DtInicio" v-bind="datePickerProps" @input="setDataHoraAtracao()">
                            </b-form-datepicker>
                        </default-form-validation-provider>
                    </b-col>
                    <b-col cols="12" sm="6" xl="4">
                        <default-form-validation-provider label="Horário da Apresentação" v-slot="defaultState">
                            <b-form-timepicker id="input-horario" :state="defaultState.state" v-model="timePickerValue"
                                v-bind="timePickerProps" @input="setDataHoraAtracao()"></b-form-timepicker>
                        </default-form-validation-provider>
                    </b-col>
                    <b-col cols="12" sm="6" xl="4">
                        <default-form-validation-provider label="Duração da apresentação (em minutos)"
                            v-slot="defState">
                            <b-form-input type="number" v-model="novoItem.VlDuracaoMinutos" :state="defState.state" />
                        </default-form-validation-provider>
                    </b-col>
                    <b-col cols="12" sm="6" xl="4">
                        <default-form-validation-provider label="Atração Local" v-slot="defState">
                            <b-form-radio-group v-model="novoItem.FlAtracaoLocal" :options="atracaoLocalOptions"
                                :state="defState.state" size="sm">
                            </b-form-radio-group>
                        </default-form-validation-provider>
                    </b-col>

                </b-row>
            </b-form>
        </validation-observer>
        <b-row class="mt-2">
            <h5 class="ml-3 w-100 titulo-mobile d-flex justify-content-between align-items-center">
                Atrações Artísticas
                <busca-tabela @busca="filtrarItens" />
            </h5>

            <b-table :fields="fields" :items="itens" :busy="tableBusy" :current-page="currentPage" hover
                no-border-collapse sort-by="" :sort-desc="true" stacked="sm" responsive show-empty>
                <template #empty>
                    <span>Não foram encontrados dados.</span>
                </template>
                <template #emptyfiltered>
                    <span>Não foram encontrados dados.</span>
                </template>
                <template #table-busy>
                    <div class="text-center text-dark">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong class="loading-text">Carregando...</strong>
                    </div>
                </template>
                <template v-slot:cell(detalhes)="row">
                    <b-link class="text-dark" @click="row.toggleDetails">
                        <font-awesome-icon :icon="row.detailsShowing ? 'chevron-up' : 'chevron-down'" />
                    </b-link>
                </template>
                <template #row-details="row">
                    <b-card no-body>
                        <b-row class="mt-2">
                            <b-col><strong>Razão Social da Atração</strong><br /><span>{{ row.item.NmFiscalAtracao
                                    }}</span></b-col>
                            <b-col><strong>Razão Social do Representante
                                    Legal</strong><br /><span>{{ row.item.NmRazaoSocialRepresentante }}</span></b-col>
                            <b-col><strong>Valor
                                    Estimado</strong><br /><span>{{ formatMoeda(row.item.VlAtracao) }}</span></b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col><strong>Data da
                                    Apresentação</strong><br /><span>{{ formatDataHora(row.item.DtInicio)
                                    }}</span></b-col>
                            <b-col><strong>Duração da Apresentação</strong><br /><span>{{ `${row.item.VlDuracaoMinutos}
                                    minutos`}}</span></b-col>
                            <b-col><strong>Previsão de término</strong><br /><span>{{ formatDataHora(new
                                Date(row.item.DtInicio.getTime() +
                                    row.item.VlDuracaoMinutos * 60000)) }}</span></b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col><strong>CPF/CNPJ da Atração
                                    Artística</strong><br /><span>{{ row.item.CdCpfCnpjAtracaoArtistica
                                    }}</span></b-col>
                            <b-col><strong>CPF/CNPJ do Representante
                                    Legal</strong><br /><span>{{ row.item.CdCpfCnpjRepresentanteLegal }}</span></b-col>
                            <b-col><strong>Atração Local</strong><br /><span>{{ row.item.FlAtracaoLocal == "S" ? "Sim" :
                                "Não" }}</span></b-col>
                        </b-row>
                    </b-card>

                </template>
                <template v-slot:cell(actions)="row">
                    <div class="actions-icons">
                        <b-link class="text-dark" @click="editarAtracaoArtistica(row.item)">
                            <font-awesome-icon icon="edit" />
                            <div style="font-size: 12px">Editar</div>
                        </b-link>
                        <btn-excluir v-if="!editItem" :key="row.item.IdItemLicitacao" :idItem="row.item"
                            :excluirItem="confirmarRemocao" />
                    </div>
                </template>
                <template #custom-foot>
                    <b-tr class="font-weight-bold">
                        <b-td colspan="5" class="text-right"></b-td>
                        <b-td class="text-right">
                            {{ programacaoVlTotal ? formatMoeda(programacaoVlTotal) : '' }}
                        </b-td>
                        <b-td></b-td>
                    </b-tr>
                </template>
            </b-table>
            <table-pagination v-if="totalRows > pageSize" :total-rows=totalRows :per-page=pageSize
                @pageChange="pageChange" />
        </b-row>
        <modal-importar-atracoes-artisticas v-if="exibirModalImportacao" @fecharModal="onFecharModalImportacao"
            :idProgramacao="prog.IdProgramacao" />
    </div>
</template>

<script lang="ts">
import TablePagination from "@/components/atos-pessoal/TablePagination.vue"
import BuscaTabela from "@/components/shared/BuscaTabela.vue"
import DefaultFormValidationProvider from '@/components/shared/DefaultFormValidationProvider.vue'
import BtnExcluir from '@/components/shared/btn-excluir.vue'
import programacaoService from '@/services/eventos/programacaoService'
import { store } from "@/store"
import { fieldEdicaoAtracaoArtistica, fieldsAtracaoArtistica, detalhes } from '@/types/eventos/programacao/fields-atracao-artistica'
import { AtracaoArtistica } from '@/types/eventos/programacao/atracao-artistica'
import { TableField } from '@/types/table-field'
import { UtilsTS } from '@/utilsts'
import { Money } from 'v-money'
import { ValidationObserver } from "vee-validate"
import { mixins } from 'vue-class-component'
import { Component, Ref, Vue } from 'vue-property-decorator'
import { DatePickerDefaultProps, TimePickerDefaultProps } from '@/types/form-default-props'
import ModalImportarAtracoesArtisticas from '../ModalImportarAtracoesArtisticas.vue'
import Multiselect from 'vue-multiselect'
import { SelectValue } from "@/types/select-value"
import { PortalError } from "@/types/portal-error"

const CompProps = Vue.extend({
    name: 'AbaEditarAtracoesArtisticas',
    components: {
        BuscaTabela, BtnExcluir, TablePagination, DefaultFormValidationProvider,
        ValidationObserver, Money, ModalImportarAtracoesArtisticas, Multiselect
    },
    props: {
        prog: {
            type: Object,
            required: true
        }
    }
})

@Component
export default class AbaEditarAtracoesArtisticas extends mixins(UtilsTS, CompProps) {
    @Ref('validationobserver') validationobserver: InstanceType<typeof ValidationObserver>
    datePickerProps = DatePickerDefaultProps
    timePickerProps = TimePickerDefaultProps
    timePickerValue = '';
    novoItem: AtracaoArtistica = new AtracaoArtistica()
    editItem = false //true para modo edição, false para modo inclusão
    atracaoLocalOptions = [
        { text: 'Sim', value: 'S' },
        { text: 'Não', value: 'N' },
    ]

    valorPadraoSelect: SelectValue = { value: null, text: 'DIGITE O NOME DO ARTISTA', disabled: true }
    outroNomeOption: SelectValue = { value: 0, text: 'OUTRO' }
    listaNomes: SelectValue[] | null = null
    nomeSelect = this.valorPadraoSelect

    //table-related
    fields: TableField[] = [detalhes, ...fieldsAtracaoArtistica, fieldEdicaoAtracaoArtistica]
    itens: AtracaoArtistica[] = []
    currentPage = 1
    pageSize = 10
    totalRows = 0
    tableBusy = false
    filtroTexto = ''
    programacaoVlTotal: number | null = null

    //modal de importação
    exibirModalImportacao = false

    getDataHoraAtracao(data: Date) {
        this.timePickerValue = `${data.getHours()}:${data.getMinutes()}`
    }

    setDataHoraAtracao() {
        if (this.timePickerValue !== '') {
            const [hora, minuto] = this.timePickerValue.split(':')
            this.novoItem.DtInicio.setHours(+hora)
            this.novoItem.DtInicio.setMinutes(+minuto)
        }
        else {
            this.novoItem.DtInicio.setHours(0)
            this.novoItem.DtInicio.setMinutes(0)
        }
    }

    validarAtracao(): boolean {
        let retorno = true;
        const cpfsNulos = !this.novoItem.CdCpfCnpjAtracaoArtistica?.trim() && !this.novoItem.CdCpfCnpjRepresentanteLegal?.trim()
        const razoesSociaisNulos = !this.novoItem.NmRazaoSocialRepresentante?.trim() && !this.novoItem.NmFiscalAtracao?.trim()
        const infoAtracaoPendente = (!this.novoItem.CdCpfCnpjAtracaoArtistica?.trim() && !!this.novoItem.NmFiscalAtracao?.trim()) || 
                                    (!!this.novoItem.CdCpfCnpjAtracaoArtistica?.trim() && !this.novoItem.NmFiscalAtracao?.trim())
        const infoRepresentantePendente = (!this.novoItem.CdCpfCnpjRepresentanteLegal?.trim() && !!this.novoItem.NmRazaoSocialRepresentante?.trim()) || 
                                          (!!this.novoItem.CdCpfCnpjRepresentanteLegal?.trim() && !this.novoItem.NmRazaoSocialRepresentante?.trim())
        if(cpfsNulos) {
            this.$toast.error('Preencha o CPF/CNPJ da Atração Artística ou o CPF/CNPJ do Representante Legal.')
            retorno = false
        }
        if(razoesSociaisNulos) {
            this.$toast.error('Preencha a Razão Social da Atração Artística ou a Razão Social do Representante Legal.')
            retorno = false
        }
        if(infoAtracaoPendente) {
            this.$toast.error('O CPF/CNPJ e a Razão Social da Atração Artística devem ser preenchidos.')
            retorno = false
        }
        if(infoRepresentantePendente) {
            this.$toast.error('O CPF/CNPJ e a Razão Social do Representante Legal devem ser preenchidos.')
            retorno = false
        }

        return retorno
    }

    /** Validar e adicionar/alterar um participante a uma licitação existente */
    async salvar(): Promise<void> {
        try {
            store.blockScreen = true
            //console.log("this.novoItem", this.novoItem)
            const isValid = await this.validationobserver.validate();
            
            if (!isValid) {
                console.error(this.validationobserver)
            } else if(this.validarAtracao()) {
                //salvar
                const retorno = await programacaoService.adicionarAtracaoArtistica(this.novoItem)
                retorno.tratarDadosDaAPI()
                this.programacaoVlTotal = retorno.VlTotal ?? 0
                this.$toast.success(`A Atração Artística ${retorno.NmAtracao} foi ${this.editItem ? 'atualizada' : 'adicionada'}.`)
                await this.loadData()
                this.limparForm()
            }
        } catch (e: any) {
            if (e.response && [400, 403].includes(e.response.status)) {
                this.tratarError(new PortalError(
                    e.response.data.erros ??
                    e.response.data.msg ??
                    "Erro ao salvar atração artística"
                ))
            } else this.tratarError(e)
        } finally {
            store.blockScreen = false
        }
    }
    limparForm(): void {
        this.novoItem = new AtracaoArtistica()
        this.nomeSelect = this.valorPadraoSelect
        this.timePickerValue = ''
        this.novoItem.IdProgramacao = this.prog.IdProgramacao
        this.editItem = false
        this.validationobserver.reset();
    }
    mounted(): void {
        this.novoItem.IdProgramacao = this.prog.IdProgramacao
        this.loadData()
    }
    async loadData(): Promise<void> {
        try {
            this.tableBusy = true
            const responseNomes = await programacaoService.buscarArtistas()
            this.listaNomes = [this.outroNomeOption, ...responseNomes.map((x, index) => { return { value: index + 1, text: x.NmArtista } })]
            const response = await programacaoService.buscarAtracoes(this.prog.IdProgramacao, this.currentPage, this.pageSize, this.filtroTexto)
            if (response) {
                this.itens = response.atracoes.map(l => {
                    const item = Object.assign(new AtracaoArtistica(), l)
                    item.tratarDadosDaAPI()
                    return item
                })
                this.totalRows = response.totalRows
                this.programacaoVlTotal = response.vlTotal
            } else {
                this.$toast.error('Erro ao consultar as atrações dessa programação.');
            }
        } finally {
            this.tableBusy = false;
        }
    }
    async pageChange(value: number): Promise<void> {
        this.currentPage = value;
        await this.loadData();
    }
    async editarAtracaoArtistica(value: AtracaoArtistica): Promise<void> {
        this.novoItem = Object.assign(new AtracaoArtistica(), value)

        this.nomeSelect = this.listaNomes?.find(x => x.text.toUpperCase() === this.removerAcentuacao(this.novoItem.NmAtracao).toUpperCase()) as SelectValue
        if (this.nomeSelect === undefined) {
            this.nomeSelect = this.outroNomeOption
        }
        else {
            this.novoItem.NmAtracao = this.nomeSelect.text
        }

        this.getDataHoraAtracao(this.novoItem.DtInicio)
        this.editItem = true
    }
    async confirmarRemocao(item: AtracaoArtistica): Promise<void> {
        try {
            await this.removerAtracaoArtistica(item)
        } catch (e: any) {
            this.tratarError(e)
        }
    }
    async removerAtracaoArtistica(item: AtracaoArtistica): Promise<void> {
        try {
            store.blockScreen = true
            const retorno = await programacaoService.removerAtracaoArtistica(item.IdAtracao)
            if (retorno) {
                await this.loadData()
            }
            else this.$toast.error(`Falha ao remover a atração ${item.NmAtracao}.`)
        } catch (e: any) {
            this.tratarError(e)
        } finally {
            store.blockScreen = false
        }
    }
    onFecharModalImportacao(refresh = false): void {
        this.exibirModalImportacao = false
        if (refresh) this.loadData()
    }

    filtrarItens(filtro: string): void {
        this.filtroTexto = filtro
        this.currentPage = 1
        this.loadData()
    }

    selectNomeAtualizado() {
        this.novoItem.NmAtracao = this.nomeSelect.text.toUpperCase() !== 'OUTRO' ? this.nomeSelect.text : ''
    }
}
</script>

<style scoped>
div.h7rem {
    height: 7rem;
}

:deep(#nomeSelectWrapper.invalid .multiselect__tags) {
    border: #dc3545 solid 1px !important;
    border-radius: 3px !important;
}

:deep(#nomeSelectWrapper.valid .multiselect__tags) {
    border: #28a745 solid 1px !important;
    border-radius: 3px !important;
}

:deep(#nomeSelectWrapper label) {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    text-align: left;
}


@media screen and (max-width: 768px) {
    div.h7rem {
        height: 10rem;
    }
}
</style>